/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { TransmittalStatusDto } from './transmittalStatusDto.schema';

export const IReadOnlyListOfTransmittalStatusDto = zod.array(zod.lazy(() => TransmittalStatusDto));

export type IReadOnlyListOfTransmittalStatusDto = zod.input<typeof IReadOnlyListOfTransmittalStatusDto>;
export type IReadOnlyListOfTransmittalStatusDtoOutput = zod.output<typeof IReadOnlyListOfTransmittalStatusDto>;
